import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import vant from 'vant';
import 'vant/lib/index.css';

/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

 createApp(App).use(store).use(router).use(vant).mount('#app')


